export default __webpack_public_path__ + "static/media/DUDA_IKONE_01.458da6f6.svg";